import { render, staticRenderFns } from "./changeMfa.vue?vue&type=template&id=bff8dc5a&"
import script from "./changeMfa.vue?vue&type=script&lang=js&"
export * from "./changeMfa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports